<template>
    <v-row style="width: 670px; height: 200px; background-color: #232323; color: white; font-size: 1.7rem;" class=" px-0 mx-0 ml-1" align="center" justify="center">
        <v-col cols="3" align="center" class="py-0 my-0 px-0 mx-0">
            <img
                :src="`${assetsUrl}/${player.image}`"
                width="auto"
                height="150px"
                contain
                @error="$event.target.src = defaultPlayerImg"
            >
        </v-col>
        <v-col cols="9" align="center" class="py-0 my-0">
            <v-row class="py-0 my-0" align="center" justify="center">
                <v-col cols="12" align="start" class="px-0 py-0 my-0 pb-16 mb-4">
                    <v-row class="my-0 mx-0 px-0 xl" style="background-color: #232323;" align="center" justify="center">
                        <v-col cols="12">
                            <div class="player-line">
                                <v-avatar style="border-radius: 10px; margin-right: 8px;" size="40px" color="white">
                                    <img
                                        :src="`${assetsUrl}/${player.teamLogo}`"
                                        width="40px"
                                        max-height="auto"
                                    >
                                </v-avatar>
                                <span class="player-name-ellipsis">
                                    {{ player.name }}
                                </span>
                                <span class="ml-2 custom-teal-text font-weight-bold">
                                    {{ getType() + '%' }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="py-0 my-0 pt-2">
                        <v-col cols="6" align="center" class="font-weight-bold px-0">
                            <span> {{ player.points }} </span>
                            <span class="custom-teal-text">{{ 'points' }}</span>
                            <div cols="12" align="center" class="px-0 py-0 my-0" style="font-size: 1.2rem;">
                                <span class="custom-teal-text font-weight-bold mr-1">fouls</span>
                                <span v-for="i in player.personalFouls + player.technicalFouls >= 5 ? 5 : player.personalFouls + player.technicalFouls" :key="`i-${i}`">
                                    <v-icon :color="player.personalFouls + player.technicalFouls >= 5 ? 'red' : 'teal'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="j in ((5 - (player.personalFouls + player.technicalFouls)) <= 0 ? 0 : (5 - (player.personalFouls + player.technicalFouls)))" :key="`j-${j}`">
                                    <v-icon color="white">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="6" align="center" class="py-0 px-0">
                            <span class="white--text" style="font-size: 1.5rem;">
                                ({{ getMade() }} / {{ getAttempts() }})
                            </span>
                            <div class="circular-border">
                                <v-progress-circular
                                    :size="90"
                                    :width="8"
                                    :value="(getMade() / getAttempts()).toFixed(2) * 100"
                                    :color="player.color"
                                >
                                    <div class="white--text" style="font-size: 1.5rem;">
                                        {{ ((getMade() / getAttempts()).toFixed(2) * 100).toFixed(0) }}%
                                    </div>
                                </v-progress-circular>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
            player: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                defaultPlayerImg: require('@/assets/default_player.png')
            }
        },
        watch: {
            match: {
                handler() {
                    this.$forceUpdate()
                },
                deep: true,
                immediate: true
            }
        },
        created() {
            this.$emit('updateEvents')
        },
        updated() {
            this.$emit('updateEvents')
        },
        methods: {
            getType() {
                if (this.type === '2P' || this.type === '3P' || this.type === '1P') {
                    return this.type
                }
                return null
            },
            getMade() {
                if (this.getType() === '2P') {
                    return this.player.twoPointsMade
                } else if (this.getType() === '3P') {
                    return this.player.threePointsMade
                } else if (this.getType() === '1P') {
                    return this.player.freeThrowsMade
                }
                return 0
            },
            getAttempts() {
                if (this.getType() === '2P') {
                    return this.player.twoPointAttempts
                } else if (this.getType() === '3P') {
                    return this.player.threePointAttempts
                } else if (this.getType() === '1P') {
                    return this.player.freeThrowAttempts
                }
                return 0
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }

    .icon-outline {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px  1px 0 #000,
            1px  1px 0 #000;
    }

    .circular-border {
        display: inline-flex;
        border: 2px solid #fff;     /* white border */
        border-radius: 50%;         /* make it circular */
        padding: 2px;               /* space between border and ring */
    }

    .player-line {
        display: flex;
        align-items: center;
    }

    .player-name-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px; /* Adjust this value as needed */
    }
</style>
